import { ShieldCheck } from "lucide-react";
import { cn } from "../lib/utils";

export function Logo({ className, withText = true, size = 32 }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="app-logo">
      <div
        className="grid place-items-center rounded-xl bg-brand text-white shadow-[0_6px_20px_-6px_rgba(92,36,255,0.7)]"
        style={{ width: size, height: size }}
      >
        <ShieldCheck style={{ width: size * 0.6, height: size * 0.6 }} strokeWidth={2.4} />
      </div>
      {withText && (
        <span className="font-heading text-xl font-extrabold tracking-tight">
          Proof<span className="text-brand">Pass</span>
        </span>
      )}
    </div>
  );
}
